import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20minimalist%20ecommerce%20flat%20lay%20with%20scattered%20straw%20hats%20linen%20scarves%20leather%20sandals%20and%20woven%20bags%20on%20a%20sunlit%20Mediterranean%20terrace%20with%20whitewashed%20walls%20and%20terracotta%20pots%2C%20warm%20golden%20hour%20light%20creating%20long%20gentle%20shadows%2C%20editorial%20lifestyle%20photography%20with%20organic%20textures%20and%20airy%20relaxed%20composition%2C%20coastal%20Italian%20summer%20aesthetic&width=1800&height=900&seq=hero-bg-itaobuy-v2-2026&orientation=landscape"
          alt="Itaobuy Spreadsheet prodotti"
          className="w-full h-full object-cover object-top"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-background-50/70 via-background-50/50 to-background-50/70"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-16">
          {/* Left Content */}
          <div className="w-full lg:w-3/5">
            {/* Tag */}
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/90 border border-background-200/50 mb-6 opacity-0 animate-fade-in-up">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="text-xs font-label font-medium text-foreground-700 whitespace-nowrap">{t('hero.tag')}</span>
            </div>

            {/* H1 */}
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-6 opacity-0 animate-fade-in-up animation-delay-200">
              {t('hero.h1_line1')}<br />
              {t('hero.h1_line2')}<br />
              {t('hero.h1_line3')}
            </h1>

            {/* Subtitle */}
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl mb-8 opacity-0 animate-fade-in-up animation-delay-400">
              {t('hero.subtitle')}
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-10 opacity-0 animate-fade-in-up animation-delay-600">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-white font-label text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                {t('hero.cta_primary')}
                <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a
                href="#categories"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-foreground-200 text-foreground-700 font-label text-sm font-medium hover:bg-background-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                {t('hero.cta_secondary')}
                <i className="ri-arrow-down-line w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>

            {/* Trust badges */}
            <div className="flex flex-wrap items-center gap-5 opacity-0 animate-fade-in-up animation-delay-600">
              {['hero.trust_1', 'hero.trust_2', 'hero.trust_3', 'hero.trust_4'].map((key) => (
                <div key={key} className="flex items-center gap-2">
                  <i className="ri-check-line text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                  <span className="text-xs text-foreground-600 font-label whitespace-nowrap">{t(key)}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="hidden lg:block w-full lg:w-2/5">
            <div className="relative">
              <div className="rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20product%20display%20on%20sunlit%20Mediterranean%20windowsill%20featuring%20a%20woven%20straw%20bag%20leather%20sandals%20and%20a%20silk%20scarf%20with%20olive%20branch%20shadows%2C%20warm%20golden%20afternoon%20light%20streaming%20through%20sheer%20curtains%2C%20soft%20dreamy%20editorial%20photography%2C%20minimalist%20luxury%20aesthetic%20with%20natural%20textures%20and%20warm%20neutral%20tones&width=700&height=900&seq=hero-side-itaobuy-v2-2026&orientation=portrait"
                  alt="Itaobuy Spreadsheet prodotti in evidenza"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}